export default __webpack_public_path__ + "static/media/kfcCup.7ca71cd3.svg";